import { cn, getInitials } from '../../lib/utils'

const sizes = {
  sm: 'w-8 h-8 text-xs',
  md: 'w-10 h-10 text-sm',
  lg: 'w-12 h-12 text-base',
  xl: 'w-16 h-16 text-lg',
}

export default function Avatar({ src, name, size = 'md', className }) {
  return (
    <div
      className={cn(
        'rounded-full bg-gradient-to-br from-teal to-navy-500',
        'flex items-center justify-center text-white font-semibold',
        'overflow-hidden flex-shrink-0',
        sizes[size],
        className
      )}
    >
      {src ? (
        <img src={src} alt={name} className="w-full h-full object-cover" />
      ) : (
        getInitials(name)
      )}
    </div>
  )
}